import { Typography, Box, useTheme} from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb="-30px" display={"flex"} justifyContent={"space-between"} alignItems={"center"} px="1.5rem">
      <Box display={"grid"}>
          <Typography
            variant="h2"
            color={colors.zamzamBrandGrey[500]}
            fontWeight="bold"
            sx={{ m: "0 0 5px 0" }}
          >
            {title}
          </Typography>
          <Typography variant="h5" color={colors.zamzamBrandGrey[400]}>
            {subtitle}
          </Typography>
      </Box>
    </Box>
  );
};

export default Header;
